var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCryptoUsdtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_4324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8019 16.2963V16.2945C16.6987 16.302 16.1672 16.3338 14.9812 16.3338C14.0344 16.3338 13.3678 16.3057 13.1334 16.2945V16.2973C9.48844 16.137 6.76781 15.5023 6.76781 14.7429C6.76781 13.9835 9.48844 13.3498 13.1334 13.1866V15.6654C13.3716 15.6823 14.0541 15.7226 14.9972 15.7226C16.1287 15.7226 16.6959 15.6757 16.8019 15.6663V13.1885C20.4394 13.3507 23.1534 13.9854 23.1534 14.7429C23.1534 15.5023 20.4394 16.1351 16.8019 16.2963ZM16.8019 12.9307V10.7126H21.8775V7.33008H8.05781V10.7126H13.1334V12.9298C9.00844 13.1191 5.90625 13.9366 5.90625 14.9154C5.90625 15.8941 9.00844 16.7107 13.1334 16.901V24.0091H16.8019V16.8991C20.9203 16.7098 24.015 15.8932 24.015 14.9154C24.015 13.9376 20.9203 13.121 16.8019 12.9307Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_4324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCryptoUsdtIcon);
export default __webpack_public_path__ + "static/media/tc_crypto_usdt_icon.bc9058792a8b20f8dd4a9a08165b688f.svg";
export { ForwardRef as ReactComponent };